import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Breadcrumbs } from 'kangarootime-ui';
import { graphql } from 'react-apollo';
import { GET_CHANNELS } from '../../graphql/queries';
import NavigationBars from '../../../../components/HOC/withNavigationBars';
import RaisedContainer from '../../../../components/RaisedContainer';
import MessagingContainer from '../../components/Container';
import ChannelSidebar from '../../components/ChannelSidebar';
import ChannelMessages from '../../components/ChannelMessages';
import NewChannelModal from '../../components/Modals/NewChannelModal';
import DirectMessageModal from '../../components/Modals/DirectMessageModal';
import CenterChannelsModal from '../../components/Modals/CenterChannelsModal';
import actions from '../../ducks/actions';
import NewBroadcastModal from '../../components/Modals/NewBroadcastModal';
import InviteAdditionalMembersToChannelModal from '../../components/Modals/InviteAdditionalMembersToChannelModal';
import ChannelInformationModal from '../../components/Modals/ChannelInformationModal';
import ChannelMembersDialog from '../../components/ChannelMembersDialog';

// localstorage keys
const LAST_ACTIVE_CHANNEL_ID_KEY = 'kangarootime-messaging::last_active_channel_id';
const LAST_ACTIVE_CHANNEL_DETAILS_KEY = 'kangarootime-messaging::last_active_channel_details';

class Messages extends Component {
  constructor (props) {
    super(props);

    this.state = {
      showNewChannelModal: false,
      showDirectMessageModal: false,
      showCenterChannelsModal: false,
      showNewBroadcastModal: false,
      showInviteAdditionalMembersToChannelModal: false,
      showChannelInformationModal: false,
      showChannelMembersDialog: false,
      directMessageChannels: []
    };
  }

  get breadcrumbs () {
    return [
      { label: 'Messages', link: null }
    ];
  }

  get lastActiveChannelId () {
    return window.localStorage.getItem(LAST_ACTIVE_CHANNEL_ID_KEY) || null;
  }

  get lastActiveChannelDetails () {
    const details = window.localStorage.getItem(LAST_ACTIVE_CHANNEL_DETAILS_KEY);

    if (details) {
      return JSON.parse(details);
    }

    return null;
  }

  componentDidMount = () => {
    this.selectLastActiveChannel();
  }

  componentWillUnmount = () => {
    // reset `selectedChannel` in redux when navigated away from messages
    this.props.selectChannel({});
  }

  componentDidUpdate = (prevProps, prevState) => {
    // user left a channel
    if (
      prevProps.data.getChannels && this.props.data.getChannels &&
      prevProps.data.getChannels.length > this.props.data.getChannels.length
    ) {
      if (this.props.data.getChannels.length > 0) {
        this.selectRandomChannel();
      }
    }
  }

  toggleNewChannelModal = () => this.setState({ showNewChannelModal: !this.state.showNewChannelModal });

  toggleDirectMessageModal = directMessages => {
    this.setState({
      showDirectMessageModal: !this.state.showDirectMessageModal,
      directMessageChannels: directMessages
    });
  }

  handleChannelSelect = (id, channel) => {
    this.writeChannelToLocalStorage(id, channel);
    this.props.selectChannel(channel);
  };

  /**
   * write channel information to localstorage
   */
  writeChannelToLocalStorage = (id, details) => {
    if (id && details && details instanceof Object) {
      window.localStorage.setItem(LAST_ACTIVE_CHANNEL_ID_KEY, id);
      window.localStorage.setItem(LAST_ACTIVE_CHANNEL_DETAILS_KEY, JSON.stringify(details));
    }
  }

  /**
   * read from localstorage and automatically select the last active channel if one is found
   */
  selectLastActiveChannel = () => {
    if (this.lastActiveChannelId && this.lastActiveChannelDetails) {
      this.handleChannelSelect(this.lastActiveChannelId, this.lastActiveChannelDetails);
    }
  }

  /**
   * select a random channel
   *
   * use cases:
   * - if a user leaves a channel they should be shown a new one
   */
  selectRandomChannel = () => {
    const { data: { getChannels } } = this.props;

    if (getChannels.length) {
      // const max = getChannels.length - 1;
      // const randomIndex = Math.floor(Math.random() * Math.floor(max));
      const randomChannel = getChannels[0];

      this.handleChannelSelect(randomChannel.id, randomChannel);
    }
  }

  render () {
    return (
      <NavigationBars>
        <div className='flex-columns flex-1'>
          <Breadcrumbs breadcrumbs={this.breadcrumbs} />
          <RaisedContainer style={{ height: '80vh' }}>
            <MessagingContainer>
              <ChannelSidebar
                channels={this.props.data.getChannels || []}
                activeChannelId={this.props.selectedChannelId}
                selectChannel={this.handleChannelSelect}
                centerName={this.props.currentCenterName}
                employeeName={this.props.employeeName}
                toggleNewChannelModal={this.toggleNewChannelModal}
                toggleDirectMessageModal={this.toggleDirectMessageModal}
                toggleCenterChannelsModal={() => this.setState({ showCenterChannelsModal: true })}
                toggleNewBroadcastModal={() => this.setState({ showNewBroadcastModal: true })}
                channelsWithNewMessages={this.props.channelsWithUnreadMessages}
                isManager={this.props.isManager}
              />
              <ChannelMessages
                activeChannelDetails={this.props.selectedChannel}
                activeChannelId={this.props.selectedChannelId}
                channelReceivedNewMessage={this.channelHasNewMessage}
                toggleChannelInformationModal={() => this.setState({ showChannelInformationModal: true })}
                toggleChannelMembersDialog={() => this.setState({ showChannelMembersDialog: true })}
              />
            </MessagingContainer>
            <NewChannelModal
              isOpen={this.state.showNewChannelModal}
              onClose={this.toggleNewChannelModal}
              currentCenterId={`${this.props.currentCenterId}`}
              employeeLegacyChatId={`employee-${this.props.legacyEmployeeId}`}
            />
            <DirectMessageModal
              isOpen={this.state.showDirectMessageModal}
              onClose={this.toggleDirectMessageModal}
              currentCenterId={`${this.props.currentCenterId}`}
              existingDirectMessages={this.state.directMessageChannels}
              onDirectMessageSelect={this.handleChannelSelect}
              existingChannels={this.props.data.getChannels || []}
              employeeLegacyChatId={`employee-${this.props.legacyEmployeeId}`}
              selectChannel={this.handleChannelSelect}
            />
            <CenterChannelsModal
              isOpen={this.state.showCenterChannelsModal}
              onClose={() => this.setState({ showCenterChannelsModal: false })}
              selectChannel={this.handleChannelSelect}
            />
            <NewBroadcastModal
              isOpen={this.state.showNewBroadcastModal}
              onClose={() => this.setState({ showNewBroadcastModal: false })}
              currentCenterName={this.props.currentCenterName}
              currentCenterId={`${this.props.currentCenterId}`}
              employeeLegacyChatId={`employee-${this.props.legacyEmployeeId}`}
              existingBroadcasts={this.props.data.getChannels ? this.props.data.getChannels.filter(channel => Boolean(channel.broadcastType) && Boolean(channel.broadcastTypeId)) : []}
            />
            <InviteAdditionalMembersToChannelModal
              isOpen={this.state.showInviteAdditionalMembersToChannelModal}
              onClose={() => this.setState({ showInviteAdditionalMembersToChannelModal: false })}
              currentCenterId={`${this.props.currentCenterId}`}
              selectedChannelId={this.props.selectedChannelId}
              selectedChannel={this.props.selectedChannel}
            />
            <ChannelInformationModal
              isOpen={this.state.showChannelInformationModal}
              onClose={() => this.setState({ showChannelInformationModal: false })}
              selectedChannel={this.props.selectedChannel}
              selectedChannelId={this.props.selectedChannelId}
              currentCenterId={this.props.currentCenterId}
              currentChatUserId={`employee-${this.props.legacyEmployeeId}`}
            />
            <ChannelMembersDialog
              isOpen={this.state.showChannelMembersDialog}
              onClose={() => this.setState({ showChannelMembersDialog: false })}
              channelId={this.props.selectedChannelId}
              canInviteAdditionalMembers={!this.props.selectedChannel.directMessage}
              showInviteAdditonalMembersModal={() => this.setState({ showInviteAdditionalMembersToChannelModal: true })}
            />
          </RaisedContainer>
        </div>
      </NavigationBars>
    );
  }
}

function mapStateToProps (state) {
  return {
    currentCenterId: state.identity.centerId,
    currentCenterName: state.identity.centers.filter(center => parseInt(center.id, 10) === parseInt(state.identity.centerId, 10))[0].name || '',
    employeeName: state.identity.name,
    legacyEmployeeId: state.identity.legacyUserId,
    selectedChannel: state.messages.selectedChannel,
    selectedChannelId: state.messages.selectedChannel.id,
    channelsWithUnreadMessages: state.messages.channelsWithUnreadMessages,
    isManager: state.identity.centers.filter(center => parseInt(center.id, 10) === parseInt(state.identity.centerId, 10))[0].permissions.admin || false
  };
}

function mapDispatchToProps (dispatch) {
  return {
    selectChannel: channel => dispatch(actions.selectChannel(channel))
  };
}

export default graphql(GET_CHANNELS, {
  options: {
    fetchPolicy: 'cache-and-network'
  }
})(connect(mapStateToProps, mapDispatchToProps)(Messages));
